import {ViewType} from 'brandConstants';
import {ProductItem} from 'coreStore/data/basket/types';
import {IProductPriceObject} from 'coreClasses/product/IProduct';
import ManagerRepository from 'coreClasses/ManagerRepository';
import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';

/**
 * Represents CartProductItemModel
 */
export default class CartProductItemModel {
	public variantId: string;
	public quantity: number;
	public price: number | IProductPriceObject;
	public masterId: string;
	public name: string;
	public brand: string;
	public size: string;
	public color: string;
	public image: string;
	public category: string;
	public url: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {ProductItem} productItem - product item
	 */
	constructor(managerRepository: ManagerRepository, productItem: ProductItem) {
		const variationGroup = managerRepository.getProductsMgr().getProduct(
			productItem?.c_variationGroupId,
		) as ProductModel;
		const product = managerRepository.getProductsMgr().getProduct(productItem.productId) as VariantModel;

		this.variantId = productItem.productId;
		this.quantity = productItem.quantity;
		this.price = productItem.priceAfterItemDiscount || product.getPriceModel().getMinPrice().value;

		this.masterId = productItem?.c_variationGroupId;
		this.name = product.getName();
		this.brand = product.getBrand();
		this.size = product.getSize(); // Get from variant
		this.color = product.getColorDescription();
		this.url = variationGroup.getProductUrl();
		this.image = variationGroup
			.getProductImage({
				viewType: ViewType.ZOOM,
				index: 0,
			})
			?.getUrl();
		this.category = variationGroup.getPrimaryCategoryId();
	}
}
